import React, { useState, useEffect } from "react";
import {
  FormLabel,
  CircularProgress,
  Divider,
  Typography,
} from "@material-ui/core";
import { useLazyQuery, useMutation, useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";

// import { EditorState } from "draft-js";
// import { Editor } from "react-draft-wysiwyg";
// import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { useAlert } from "../../components/Alert";
import { Card, CardContent, CardActions } from "../../components/Card";
import Grid from "../../components/Grid";
import Text from "../../components/Text";
import Button from "../../components/Button";
import { TextInput } from "../../components/Form";
import LoadingModal from "../../components/LoadingModal";

const GET_SECRET = gql`
  query secret($id: Int!) {
    secret(id: $id) {
      id
      questioner {
        id
        fullName
      }
      secretAnswer {
        id
        answerer {
          id
          fullName
        }
        content
        createdAt
      }
      title
      content
      createdAt
    }
  }
`;

const ANSWERSECRET = gql`
  mutation answerSecret($secretId: Int!, $answererId: Int!, $content: String!) {
    answerSecret(
      secretId: $secretId
      answererId: $answererId
      content: $content
    )
  }
`;

const DELETE_ANSWER = gql`
  mutation deleteAnswer($id: Int!) {
    deleteAnswer(id: $id)
  }
`;

export default function SaleSecretForum({ id }) {
  const Alert = useAlert();
  // const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [content, setContent] = useState("");
  const [getSecret, { data, loading }] = useLazyQuery(GET_SECRET, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });
  const [answerSecret, { loading: answerSecretLoading }] = useMutation(
    ANSWERSECRET,
    {
      onCompleted({ answerSecret }) {
        if (answerSecret) {
          return Alert.alert("", "回覆成功！", [
            {
              text: "確定",
              onPress: () => {
                getSecret({ variables: { id } });
                setContent("");
              },
              type: "ok",
            },
          ]);
        } else {
          return Alert.alert("", "回覆失敗！", [
            {
              text: "確定",
              type: "ok",
            },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );
  const [deleteAnswer, { loading: deleteAnswerLoading }] = useMutation(
    DELETE_ANSWER,
    {
      onCompleted({ deleteAnswer }) {
        if (deleteAnswer) {
          return Alert.alert("", "刪除成功！", [
            {
              text: "確定",
              onPress: () => {
                getSecret({ variables: { id } });
              },
              type: "ok",
            },
          ]);
        } else {
          return Alert.alert("", "刪除失敗！", [
            {
              text: "確定",
              type: "ok",
            },
          ]);
        }
      },
      onError(error) {
        Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
      },
    }
  );
  function save() {
    answerSecret({
      variables: {
        secretId: id,
        answererId: Number(localStorage.getItem("@fullhouseUserId")),
        content,
      },
    });
  }

  useEffect(() => {
    if (id) getSecret({ variables: { id } });
  }, [id]);
  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Card>
        <LoadingModal loading={deleteAnswerLoading || answerSecretLoading} />
        <CardContent>
          <Grid container justify="center">
            <FormLabel>問題:</FormLabel>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container spacing={3}>
            <Grid container item direction="row" spacing={1}>
              <Grid item xs={12} sm={6} md={3} lg={3}>
                <FormLabel>提問{`\u2002`}</FormLabel>
                <Text>{data?.secret.questioner.fullName}</Text>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="column" spacing={1}>
              <Grid container item justify="center">
                <Text>{data?.secret.content}</Text>
              </Grid>
            </Grid>
            <Grid container item xs={12} direction="column" spacing={1}>
              <Grid container item justify="flex-end">
                <FormLabel>發問時間</FormLabel>
              </Grid>
              <Grid container item justify="flex-end">
                <Text>
                  {moment(data?.secret.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                </Text>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid container justify="center">
            <FormLabel>回答:</FormLabel>
          </Grid>
        </CardContent>
        <Divider />
        {data?.secret.secretAnswer.map((item) => (
          <>
            <Grid>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid container item direction="row" spacing={1}>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                      <FormLabel>回覆{`\u2002`}</FormLabel>
                      <Text>{item.answerer.fullName}</Text>
                    </Grid>
                    <Grid container justify="flex-end">
                      <Button
                        variant="contained"
                        color="primary"
                        onPress={(event) => {
                          event.stopPropagation();
                          Alert.alert("", "確定要刪除？", [
                            {
                              text: "確定",
                              onPress: () =>
                                deleteAnswer({
                                  variables: { id: Number(item.id) },
                                }),
                              type: "ok",
                            },
                            {
                              text: "取消",
                              type: "cancel",
                            },
                          ]);
                        }}
                      >
                        刪除
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12} direction="column" spacing={1}>
                    <Grid container item justify="center">
                      <Text>{item.content}</Text>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12} direction="column" spacing={1}>
                    <Grid container item justify="flex-end">
                      <FormLabel>回答時間</FormLabel>
                    </Grid>
                    <Grid container item justify="flex-end">
                      <Text>
                        {moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                      </Text>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Grid>
            <Divider />
          </>
        ))}
        <CardContent>
          <Grid container justify="center">
            <FormLabel>我要回答:</FormLabel>
          </Grid>
        </CardContent>
        <Divider />
        <CardContent>
          <Grid item xs={12} sm={12}>
            <TextInput
              value={content}
              rows={10}
              multiline
              onChange={(v) => setContent(v)}
              fullWidth
            />
            {/* <Editor
              toolbar={{
                options: ["fontSize", "colorPicker", "image", "link"],
              }}
              initialEditorState={editorState}
              toolbarClassName="toolbar"
              wrapperClassName="wrapper"
              editorClassName="editor"
              editorStyle={{
                border: "1px solid",
                height: "300px",
                width: "100%",
              }}
              localization={{
                locale: 'zh_tw',
              }}
              onEditorStateChange={(e) =>setEditorState(e) }
            /> */}
          </Grid>
        </CardContent>
        <Divider />
        <CardActions>
          <Grid container justifyContent="center">
            <Button color="primary" variant="contained" onPress={save}>
              送出
            </Button>
          </Grid>
        </CardActions>
      </Card>
    );
  }
}

{
  /* 回答的部分 {data.questionAndAnswer.answers.map((item, index) => (
    <Grid>
      <CardContent>
        <Grid container spacing={3}>
          <Grid container item direction="row" spacing={1}>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <FormLabel>提問者{`\u2002`}</FormLabel>
              <Text>{item.answerer.username}</Text>
            </Grid>
            <Grid container justify="flex-end">
              <Button
                variant="contained"
                color="primary"
                onPress={(event) => {
                  event.stopPropagation();
                  Alert.alert("", "確定要刪除？", [
                    {
                      text: "確定",
                      onPress: () =>
                        hideAnswer({
                          variables: { id: Number(item.id) },
                        }),
                      type: "ok",
                    },
                    {
                      text: "取消",
                      type: "cancel",
                    },
                  ]);
                }}
              >
                刪除
              </Button>
            </Grid>
          </Grid>
          <Grid container item xs={12} direction="column" spacing={1}>
            <Grid container item justify="center">
              <FormLabel>內容</FormLabel>
            </Grid>
            <Grid container item justify="center">
              {item.answer.split("\n").map((item2, index) => (
                <Text key={index}>{item2}</Text>
              ))}
            </Grid>
          </Grid>
          <Grid container item xs={12} direction="column" spacing={1}>
            <Grid container item justify="flex-end">
              <FormLabel>回答時間</FormLabel>
            </Grid>
            <Grid container item justify="flex-end">
              <Text>
                {moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
              </Text>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      {index !== data.questionAndAnswer.answers.length - 1 && <Divider />}
    </Grid>
  ))} */
}
